// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Onboarding Styles */

/* Onboarding wrapper: full width (s-page is provided by App.js with inlineSize="large") */
.onboarding-page-wrapper {
  width: 100%;
  max-width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;
}

.onboarding-page-wrapper .onboarding-container {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* Force full width on onboarding s-section so it matches other pages */
.onboarding-page-wrapper .onboarding-container s-section {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* Common Layout */
.onboarding-container {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 2rem;
  box-sizing: border-box;
}

.onboarding-step-heading {
  text-align: center;
  margin-bottom: 3rem;
}

.step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0;
  margin: 0;
}

.step-dot {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background-color: #5C6AC4;
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.step-dot:disabled {
  cursor: default;
  opacity: 1;
}

.step-dot.completed {
  background-color: #5C6AC4;
  color: #fff;
}

.step-dot.current {
  background-color: #5C6AC4;
  color: #fff;
}

.step-connector {
  width: 48px;
  height: 2px;
  background-color: #E5E7EB;
}

/* Loading States */
.onboarding-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.onboarding-loading-grid {
  width: 100%;
}

.onboarding-error {
  text-align: center;
  padding: 2rem;
}

/* Compression Type Step */
.compression-types-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.25rem;
  margin-top: 1rem;
}

.compression-type-card-wrapper {
  cursor: pointer;
  outline: none;
  flex: 1;
  min-width: 280px;
}

.compression-type-card {
  border: 2px solid #E1E3E5;
  background-color: #FFFFFF;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 1.25rem;
  min-height: 140px;
  height: 140px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: pointer;
}

.compression-type-card.selected {
  border: 2px solid #5C6AC4;
  background-color: #F8F9FF;
  box-shadow: 0 4px 12px rgba(92, 106, 196, 0.12);
}

.compression-type-card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}

.compression-type-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 32px;
  margin-bottom: 0.5rem;
}

.compression-type-title {
  font-weight: 600;
  margin: 0;
}

.compression-type-selected-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.compression-type-selected-placeholder {
  width: 100px;
  height: 24px;
  flex-shrink: 0;
}

.compression-type-selected-indicator {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #5C6AC4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
}

.compression-type-selected-text {
  font-weight: 500;
}

.compression-type-description {
  line-height: 1.6;
  margin: 0;
  flex: 1;
}

.compression-type-button-container {
  display: flex;
  justify-content: center;
  margin: 1rem 0;
}

/* Pricing Step - max 3 cards per row, extra cards centered on next row */
.pricing-cards-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  width: 100%;
  max-width: 100%;
  margin: 2rem 0 0;
  box-sizing: border-box;
}

.pricing-card-wrapper {
  position: relative;
  display: flex;
  flex: 0 1 calc((100% - 3rem) / 3);
  min-width: 220px;
  max-width: 340px;
}

.pricing-card-popular-badge {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
  color: #FFFFFF;
  padding: 4px 12px;
  border-radius: 14px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  z-index: 1;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.3);
}

.pricing-card {
  outline: none;
  border: 1.5px solid #E5E7EB;
  background-color: #FFFFFF;
  border-radius: 16px;
  padding: 2rem 1.75rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 420px;
  box-sizing: border-box;
  position: relative;
}

/* Hover border commented out - not needed for now
.pricing-card:hover {
  border-color: #5C6AC4;
  box-shadow: 0 4px 16px rgba(92, 106, 196, 0.12);
  transform: translateY(-2px);
}
*/

.pricing-card s-stack {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  gap: 0;
}

/* Selected state commented out - not needed for now
.pricing-card.selected {
  border: 2px solid #5C6AC4;
  background: linear-gradient(135deg, #F8F9FF 0%, #FFFFFF 100%);
  box-shadow: 0 8px 24px rgba(92, 106, 196, 0.2);
  transform: translateY(-4px);
}
*/

.pricing-card-title {
  text-align: left;
  margin: 0 0 0.35rem 0;
  padding: 0;
}

.pricing-card-title.with-badge {
  margin-top: 10px;
}

.pricing-card-title-text {
  font-size: 18px;
  font-weight: 700;
  color: #1F2937;
  margin: 0;
  letter-spacing: -0.02em;
}

.pricing-card-quota-container {
  text-align: left;
  margin: 0 0 0.25rem 0;
  padding: 0;
}

.pricing-card-quota-large {
  font-weight: 700;
  font-size: 0.78rem;
  line-height: 1.4;
  display: block;
  color: #6B7280;
  margin: 0;
  letter-spacing: 0;
}

.pricing-card-quota-description {
  display: none;
}

.pricing-card-price-container {
  text-align: left;
  margin: 0;
  padding: 1.25rem 0 1rem 0;
  border-bottom: 1px solid #F3F4F6;
}

.pricing-card-price-large {
  font-weight: 800;
  font-size: 2.5rem;
  line-height: 1;
  display: inline;
  color: #111827;
  margin: 0;
  letter-spacing: -0.03em;
}

.pricing-card-price-period {
  display: inline;
  font-size: 13px;
  font-weight: 500;
  color: #9CA3AF;
  margin-left: 4px;
}

/* Plan Features List */
.pricing-card-features-list {
  list-style: none;
  margin: 1.25rem 0 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  flex: 1;
}

.pricing-card-feature-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.pricing-card-feature-check {
  width: 18px;
  height: 18px;
  min-width: 18px;
  border-radius: 50%;
  background-color: #DCFCE7;
  color: #16A34A;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pricing-card-feature-text {
  font-size: 13.5px;
  color: #374151;
  font-weight: 450;
  line-height: 1.4;
}

/* Select Plan Button */
.pricing-card-select-button {
  margin-top: auto;
  padding-top: 1.5rem;
  width: 100%;
}

.pricing-card-select-button s-button,
.pricing-card-select-button > * {
  width: 100%;
}

/* Selected Indicator (commented out in JSX - kept here for reference)
.pricing-card-selected-indicator-ref {
  display: none;
}
*/

.pricing-card-selected-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  margin-top: auto;
  padding-top: 1rem;
  color: #5C6AC4;
  font-weight: 600;
  font-size: 13px;
  min-height: 36px;
}

.pricing-card-selected-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #5C6AC4;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  flex-shrink: 0;
}

.pricing-card-selected-text {
  font-weight: 600;
}

/* Shimmer: same size as real cards so 3 static cards with proper width */
.pricing-card-shimmer-wrapper {
  position: relative;
  display: flex;
  flex: 0 1 calc((100% - 2rem) / 3);
  min-width: 200px;
  max-width: 320px;
}

.pricing-card-shimmer {
  width: 100%;
  min-height: 420px;
  border-radius: 16px;
  padding: 2rem 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #E1E3E5;
}

.shimmer-line {
  position: relative;
  overflow: hidden;
  background: #E1E3E5;
  border-radius: 4px;
}

.shimmer-line::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    #E1E3E5 0%,
    #E1E3E5 40%,
    rgba(255, 255, 255, 0.6) 50%,
    #E1E3E5 60%,
    #E1E3E5 100%
  );
  background-size: 200% 100%;
  animation: shimmer-slide 1.5s ease-in-out infinite;
}

.shimmer-title {
  height: 24px;
  width: 60%;
  margin: 0 auto;
}

.shimmer-quota {
  height: 64px;
  width: 70%;
  margin: 1.5rem auto 0.5rem;
}

.shimmer-price {
  height: 48px;
  width: 45%;
  margin: 0.5rem auto;
}

.shimmer-description {
  height: 20px;
  width: 55%;
  margin: 0.5rem auto;
}

@keyframes shimmer-slide {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Compression Type Shimmer — matches real card exactly */
.compression-type-card-shimmer {
  border: 2px solid #E1E3E5;
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 1.25rem;
  height: 140px;
  min-height: 140px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: hidden;
}

.shimmer-compression-title {
  height: 28px;
  width: 40%;
}

.shimmer-compression-description {
  height: 40px;
  width: 100%;
}

/* Comparison Table Shimmer */
.comparison-table-shimmer {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.shimmer-table-header {
  height: 48px;
  width: 100%;
  margin-bottom: 0.5rem;
}

.shimmer-table-row {
  height: 56px;
  width: 100%;
}

/* Comparison Table */
.comparison-table-container {
  padding: 2.5rem;
  background-color: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #E1E3E5;
  margin-top: 3rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.comparison-table-container s-heading {
  text-align: center;
}

.comparison-table-wrapper {
  overflow-x: auto;
  margin-top: 1rem;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

.comparison-table thead tr {
  border-bottom: 2px solid #E1E3E5;
}

.comparison-table th {
  text-align: left;
  padding: 1.25rem 1rem;
  font-weight: 700;
  font-size: 16px;
  color: #111827;
}

.comparison-table th.center {
  text-align: center;
}

.comparison-table tbody tr {
  border-bottom: 1px solid #E1E3E5;
}

.comparison-table tbody tr:nth-child(even) {
  background-color: #F9FAFB;
}

.comparison-table tbody tr:nth-child(odd) {
  background-color: #FFFFFF;
}

.comparison-table td {
  padding: 1.25rem 1rem;
  font-weight: 500;
  font-size: 15px;
  color: #374151;
}

.comparison-table td.center {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}

.comparison-table td.disabled {
  color: #9CA3AF;
}

.comparison-buttons-container {
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.comparison-buttons-row {
  display: table-row;
}

.comparison-buttons-cell {
  display: table-cell;
  padding: 1rem;
  vertical-align: middle;
}

.comparison-buttons-cell.feature {
  width: 40%;
}

.comparison-buttons-cell.plan {
  width: 30%;
  text-align: center;
}

.comparison-button {
  width: 100%;
  max-width: 200px;
}

/* FAQ Section */
.faq-container {
  padding: 2rem;
  background-color: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #E1E3E5;
}

.faq-container s-heading {
  text-align: center;
}

.faq-card {
  background-color: #F9FAFB;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #E1E3E5;
}

.faq-question-wrapper {
  cursor: pointer;
  outline: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.faq-question-text {
  flex: 1;
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

.faq-toggle-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 1rem;
  border: 1px solid #E1E3E5;
  flex-shrink: 0;
}

.faq-toggle-icon-text {
  color: #5C6AC4;
  line-height: 1;
  font-size: 18px;
  font-weight: 500;
}

.faq-answer {
  padding: 1rem 0 0 0;
  margin-top: 0.5rem;
  border-top: 1px solid #E1E3E5;
}

.faq-answer-text {
  line-height: 1.6;
  margin: 0;
  font-size: 14px;
  color: #6B7280;
}

/* Final Step */
.final-step-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
}

.final-step-card {
  padding: 2.5rem 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background-color: #FFFFFF;
  border: 1px solid #E1E3E5;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.final-step-icon-container {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #E3F2FD;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.final-step-check-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #0B7B5E;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: bold;
}

.final-step-heading {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.final-step-description {
  text-align: center;
  max-width: 500px;
  line-height: 1.6;
}

.final-step-error-container {
  background-color: #FEF2F2;
  border: 1px solid #FCA5A5;
  border-radius: 8px;
  padding: 1.5rem;
  width: 100%;
  max-width: 600px;
  margin-top: 1rem;
}

.final-step-error-text {
  font-weight: 500;
}

.final-step-error-subtext {
  margin-bottom: 1rem;
}

.final-step-button-container {
  margin-top: 1.5rem;
  width: 100%;
  max-width: 340px;
}

.final-step-button {
  width: 100%;
  padding: 0.875rem 1.5rem;
  font-size: 1rem;
}

`, "",{"version":3,"sources":["webpack://./src/components/onboarding/onboarding.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB,0FAA0F;AAC1F;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;;;;CAMC;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,MAAM;AACR;;AAEA;;;;;;;CAOC;;AAED;EACE,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;CAIC;;AAED;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;;;GAOC;EACD,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,eAAe;AACjB","sourcesContent":["/* Onboarding Styles */\n\n/* Onboarding wrapper: full width (s-page is provided by App.js with inlineSize=\"large\") */\n.onboarding-page-wrapper {\n  width: 100%;\n  max-width: 100%;\n  padding: 0 1rem;\n  box-sizing: border-box;\n}\n\n.onboarding-page-wrapper .onboarding-container {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n/* Force full width on onboarding s-section so it matches other pages */\n.onboarding-page-wrapper .onboarding-container s-section {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n/* Common Layout */\n.onboarding-container {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 2rem;\n  box-sizing: border-box;\n}\n\n.onboarding-step-heading {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.step-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 0;\n  margin: 0;\n}\n\n.step-dot {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: none;\n  background-color: #5C6AC4;\n  color: #fff;\n  font-weight: 700;\n  font-size: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n}\n\n.step-dot:disabled {\n  cursor: default;\n  opacity: 1;\n}\n\n.step-dot.completed {\n  background-color: #5C6AC4;\n  color: #fff;\n}\n\n.step-dot.current {\n  background-color: #5C6AC4;\n  color: #fff;\n}\n\n.step-connector {\n  width: 48px;\n  height: 2px;\n  background-color: #E5E7EB;\n}\n\n/* Loading States */\n.onboarding-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n.onboarding-loading-grid {\n  width: 100%;\n}\n\n.onboarding-error {\n  text-align: center;\n  padding: 2rem;\n}\n\n/* Compression Type Step */\n.compression-types-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.25rem;\n  margin-top: 1rem;\n}\n\n.compression-type-card-wrapper {\n  cursor: pointer;\n  outline: none;\n  flex: 1;\n  min-width: 280px;\n}\n\n.compression-type-card {\n  border: 2px solid #E1E3E5;\n  background-color: #FFFFFF;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border-radius: 10px;\n  padding: 1.25rem;\n  min-height: 140px;\n  height: 140px;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  cursor: pointer;\n}\n\n.compression-type-card.selected {\n  border: 2px solid #5C6AC4;\n  background-color: #F8F9FF;\n  box-shadow: 0 4px 12px rgba(92, 106, 196, 0.12);\n}\n\n.compression-type-card-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: space-between;\n}\n\n.compression-type-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 32px;\n  margin-bottom: 0.5rem;\n}\n\n.compression-type-title {\n  font-weight: 600;\n  margin: 0;\n}\n\n.compression-type-selected-badge {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.compression-type-selected-placeholder {\n  width: 100px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.compression-type-selected-indicator {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #5C6AC4;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 14px;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n.compression-type-selected-text {\n  font-weight: 500;\n}\n\n.compression-type-description {\n  line-height: 1.6;\n  margin: 0;\n  flex: 1;\n}\n\n.compression-type-button-container {\n  display: flex;\n  justify-content: center;\n  margin: 1rem 0;\n}\n\n/* Pricing Step - max 3 cards per row, extra cards centered on next row */\n.pricing-cards-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1.5rem;\n  width: 100%;\n  max-width: 100%;\n  margin: 2rem 0 0;\n  box-sizing: border-box;\n}\n\n.pricing-card-wrapper {\n  position: relative;\n  display: flex;\n  flex: 0 1 calc((100% - 3rem) / 3);\n  min-width: 220px;\n  max-width: 340px;\n}\n\n.pricing-card-popular-badge {\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: linear-gradient(135deg, #10B981 0%, #059669 100%);\n  color: #FFFFFF;\n  padding: 4px 12px;\n  border-radius: 14px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  z-index: 1;\n  white-space: nowrap;\n  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.3);\n}\n\n.pricing-card {\n  outline: none;\n  border: 1.5px solid #E5E7EB;\n  background-color: #FFFFFF;\n  border-radius: 16px;\n  padding: 2rem 1.75rem;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n  width: 100%;\n  min-width: 0;\n  height: 100%;\n  min-height: 420px;\n  box-sizing: border-box;\n  position: relative;\n}\n\n/* Hover border commented out - not needed for now\n.pricing-card:hover {\n  border-color: #5C6AC4;\n  box-shadow: 0 4px 16px rgba(92, 106, 196, 0.12);\n  transform: translateY(-2px);\n}\n*/\n\n.pricing-card s-stack {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  height: 100%;\n  gap: 0;\n}\n\n/* Selected state commented out - not needed for now\n.pricing-card.selected {\n  border: 2px solid #5C6AC4;\n  background: linear-gradient(135deg, #F8F9FF 0%, #FFFFFF 100%);\n  box-shadow: 0 8px 24px rgba(92, 106, 196, 0.2);\n  transform: translateY(-4px);\n}\n*/\n\n.pricing-card-title {\n  text-align: left;\n  margin: 0 0 0.35rem 0;\n  padding: 0;\n}\n\n.pricing-card-title.with-badge {\n  margin-top: 10px;\n}\n\n.pricing-card-title-text {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1F2937;\n  margin: 0;\n  letter-spacing: -0.02em;\n}\n\n.pricing-card-quota-container {\n  text-align: left;\n  margin: 0 0 0.25rem 0;\n  padding: 0;\n}\n\n.pricing-card-quota-large {\n  font-weight: 700;\n  font-size: 0.78rem;\n  line-height: 1.4;\n  display: block;\n  color: #6B7280;\n  margin: 0;\n  letter-spacing: 0;\n}\n\n.pricing-card-quota-description {\n  display: none;\n}\n\n.pricing-card-price-container {\n  text-align: left;\n  margin: 0;\n  padding: 1.25rem 0 1rem 0;\n  border-bottom: 1px solid #F3F4F6;\n}\n\n.pricing-card-price-large {\n  font-weight: 800;\n  font-size: 2.5rem;\n  line-height: 1;\n  display: inline;\n  color: #111827;\n  margin: 0;\n  letter-spacing: -0.03em;\n}\n\n.pricing-card-price-period {\n  display: inline;\n  font-size: 13px;\n  font-weight: 500;\n  color: #9CA3AF;\n  margin-left: 4px;\n}\n\n/* Plan Features List */\n.pricing-card-features-list {\n  list-style: none;\n  margin: 1.25rem 0 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  flex: 1;\n}\n\n.pricing-card-feature-item {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.pricing-card-feature-check {\n  width: 18px;\n  height: 18px;\n  min-width: 18px;\n  border-radius: 50%;\n  background-color: #DCFCE7;\n  color: #16A34A;\n  font-size: 10px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.pricing-card-feature-text {\n  font-size: 13.5px;\n  color: #374151;\n  font-weight: 450;\n  line-height: 1.4;\n}\n\n/* Select Plan Button */\n.pricing-card-select-button {\n  margin-top: auto;\n  padding-top: 1.5rem;\n  width: 100%;\n}\n\n.pricing-card-select-button s-button,\n.pricing-card-select-button > * {\n  width: 100%;\n}\n\n/* Selected Indicator (commented out in JSX - kept here for reference)\n.pricing-card-selected-indicator-ref {\n  display: none;\n}\n*/\n\n.pricing-card-selected-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  margin-top: auto;\n  padding-top: 1rem;\n  color: #5C6AC4;\n  font-weight: 600;\n  font-size: 13px;\n  min-height: 36px;\n}\n\n.pricing-card-selected-icon {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #5C6AC4;\n  color: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n.pricing-card-selected-text {\n  font-weight: 600;\n}\n\n/* Shimmer: same size as real cards so 3 static cards with proper width */\n.pricing-card-shimmer-wrapper {\n  position: relative;\n  display: flex;\n  flex: 0 1 calc((100% - 2rem) / 3);\n  min-width: 200px;\n  max-width: 320px;\n}\n\n.pricing-card-shimmer {\n  width: 100%;\n  min-height: 420px;\n  border-radius: 16px;\n  padding: 2rem 1.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box;\n  background-color: #fff;\n  border: 1px solid #E1E3E5;\n}\n\n.shimmer-line {\n  position: relative;\n  overflow: hidden;\n  background: #E1E3E5;\n  border-radius: 4px;\n}\n\n.shimmer-line::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    #E1E3E5 0%,\n    #E1E3E5 40%,\n    rgba(255, 255, 255, 0.6) 50%,\n    #E1E3E5 60%,\n    #E1E3E5 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer-slide 1.5s ease-in-out infinite;\n}\n\n.shimmer-title {\n  height: 24px;\n  width: 60%;\n  margin: 0 auto;\n}\n\n.shimmer-quota {\n  height: 64px;\n  width: 70%;\n  margin: 1.5rem auto 0.5rem;\n}\n\n.shimmer-price {\n  height: 48px;\n  width: 45%;\n  margin: 0.5rem auto;\n}\n\n.shimmer-description {\n  height: 20px;\n  width: 55%;\n  margin: 0.5rem auto;\n}\n\n@keyframes shimmer-slide {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n/* Compression Type Shimmer — matches real card exactly */\n.compression-type-card-shimmer {\n  border: 2px solid #E1E3E5;\n  background-color: #FFFFFF;\n  border-radius: 10px;\n  padding: 1.25rem;\n  height: 140px;\n  min-height: 140px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  overflow: hidden;\n}\n\n.shimmer-compression-title {\n  height: 28px;\n  width: 40%;\n}\n\n.shimmer-compression-description {\n  height: 40px;\n  width: 100%;\n}\n\n/* Comparison Table Shimmer */\n.comparison-table-shimmer {\n  margin-top: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.shimmer-table-header {\n  height: 48px;\n  width: 100%;\n  margin-bottom: 0.5rem;\n}\n\n.shimmer-table-row {\n  height: 56px;\n  width: 100%;\n}\n\n/* Comparison Table */\n.comparison-table-container {\n  padding: 2.5rem;\n  background-color: #FFFFFF;\n  border-radius: 12px;\n  border: 1px solid #E1E3E5;\n  margin-top: 3rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.comparison-table-container s-heading {\n  text-align: center;\n}\n\n.comparison-table-wrapper {\n  overflow-x: auto;\n  margin-top: 1rem;\n}\n\n.comparison-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 15px;\n}\n\n.comparison-table thead tr {\n  border-bottom: 2px solid #E1E3E5;\n}\n\n.comparison-table th {\n  text-align: left;\n  padding: 1.25rem 1rem;\n  font-weight: 700;\n  font-size: 16px;\n  color: #111827;\n}\n\n.comparison-table th.center {\n  text-align: center;\n}\n\n.comparison-table tbody tr {\n  border-bottom: 1px solid #E1E3E5;\n}\n\n.comparison-table tbody tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.comparison-table tbody tr:nth-child(odd) {\n  background-color: #FFFFFF;\n}\n\n.comparison-table td {\n  padding: 1.25rem 1rem;\n  font-weight: 500;\n  font-size: 15px;\n  color: #374151;\n}\n\n.comparison-table td.center {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.comparison-table td.disabled {\n  color: #9CA3AF;\n}\n\n.comparison-buttons-container {\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.comparison-buttons-row {\n  display: table-row;\n}\n\n.comparison-buttons-cell {\n  display: table-cell;\n  padding: 1rem;\n  vertical-align: middle;\n}\n\n.comparison-buttons-cell.feature {\n  width: 40%;\n}\n\n.comparison-buttons-cell.plan {\n  width: 30%;\n  text-align: center;\n}\n\n.comparison-button {\n  width: 100%;\n  max-width: 200px;\n}\n\n/* FAQ Section */\n.faq-container {\n  padding: 2rem;\n  background-color: #FFFFFF;\n  border-radius: 8px;\n  border: 1px solid #E1E3E5;\n}\n\n.faq-container s-heading {\n  text-align: center;\n}\n\n.faq-card {\n  background-color: #F9FAFB;\n  border-radius: 8px;\n  padding: 1rem;\n  border: 1px solid #E1E3E5;\n}\n\n.faq-question-wrapper {\n  cursor: pointer;\n  outline: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.faq-question-text {\n  flex: 1;\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.faq-toggle-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 1rem;\n  border: 1px solid #E1E3E5;\n  flex-shrink: 0;\n}\n\n.faq-toggle-icon-text {\n  color: #5C6AC4;\n  line-height: 1;\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.faq-answer {\n  padding: 1rem 0 0 0;\n  margin-top: 0.5rem;\n  border-top: 1px solid #E1E3E5;\n}\n\n.faq-answer-text {\n  line-height: 1.6;\n  margin: 0;\n  font-size: 14px;\n  color: #6B7280;\n}\n\n/* Final Step */\n.final-step-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.final-step-card {\n  padding: 2.5rem 2rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  background-color: #FFFFFF;\n  border: 1px solid #E1E3E5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.final-step-icon-container {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background-color: #E3F2FD;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.final-step-check-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: #0B7B5E;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.final-step-heading {\n  text-align: center;\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n.final-step-description {\n  text-align: center;\n  max-width: 500px;\n  line-height: 1.6;\n}\n\n.final-step-error-container {\n  background-color: #FEF2F2;\n  border: 1px solid #FCA5A5;\n  border-radius: 8px;\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 600px;\n  margin-top: 1rem;\n}\n\n.final-step-error-text {\n  font-weight: 500;\n}\n\n.final-step-error-subtext {\n  margin-bottom: 1rem;\n}\n\n.final-step-button-container {\n  margin-top: 1.5rem;\n  width: 100%;\n  max-width: 340px;\n}\n\n.final-step-button {\n  width: 100%;\n  padding: 0.875rem 1.5rem;\n  font-size: 1rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
